import { SkeletonModule } from 'primeng/skeleton';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule, DatePipe} from "@angular/common";
import {ToastModule} from "primeng/toast";
import {MenubarModule} from "primeng/menubar";
import {TieredMenuModule} from "primeng/tieredmenu";
import {AvatarModule} from "primeng/avatar";
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {AccordionModule} from "primeng/accordion";
import {SelectModule} from 'primeng/select';
import {InputTextModule} from "primeng/inputtext";
import {TranslocoModule} from "@jsverse/transloco";
import {YearDatepipe} from "./pipes/year.datepipe";
import {FileUploadModule} from "primeng/fileupload";
import {WaitingDialogComponent} from './components/waiting-dialog/waiting-dialog.component';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ScrollTopModule} from 'primeng/scrolltop';
import {AnimalImageContainerComponent} from './components/animal-image-container/animal-image-container.component';
import {ImageModule} from 'primeng/image';
import {PaginatorModule} from 'primeng/paginator';
import {TableModule} from 'primeng/table';
import {DialogModule} from 'primeng/dialog';
import {BarcodeScannerComponent} from './components/barcode-scanner/barcode-scanner.component';
import {DatePickerModule} from 'primeng/datepicker';
import {CalendarMaxDateDirective} from './directives/calendar-max-date.directive';
import {AnimalVideoContainerComponent} from "./components/animal-video-container/animal-video-container.component";
import {TooltipModule} from 'primeng/tooltip';
import {AnimalInStockIconComponent} from './components/animal-in-stock-icon/animal-in-stock-icon.component';
import {AnimalLabelsComponent} from "./components/animal-labels/animal-labels.component";
import {ScrollerModule} from 'primeng/scroller';
import {CustomDatePickerComponent} from './components/custom-date-picker/custom-date-picker.component';
import {ToggleSwitchModule} from 'primeng/toggleswitch';
import {TabsModule} from 'primeng/tabs';
import '../shared/translation-keys';
import {DialogService, DynamicDialogModule} from 'primeng/dynamicdialog';
import {PanelModule} from "primeng/panel";
import {MediaUploadComponent} from './components/media-upload/media-upload.component';
import {SelectButtonModule} from 'primeng/selectbutton';
import {DividerModule} from 'primeng/divider';
import {CheckboxModule} from 'primeng/checkbox';
import {InputGroupModule} from "primeng/inputgroup";
import {IftaLabelModule} from "primeng/iftalabel";
import {InputGroupAddonModule} from "primeng/inputgroupaddon";
import {Chip} from "primeng/chip";
import {Fieldset} from "primeng/fieldset";
import {InputOtpModule} from 'primeng/inputotp';
import { AnimalListItemComponent } from './components/animal-list-item/animal-list-item.component';
import { RouterModule } from '@angular/router';
import { AnimalUniqueCheckDirective } from './directives/animal-unique-check.directive';
import { BodyConditionScoreComponent } from './components/body-condition-score/body-condition-score.component';
import { MotherSelectComponent } from './components/mother-select/mother-select.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { SignaturePadComponent } from './components/signature-pad/signature-pad.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';

@NgModule({
  declarations: [
    YearDatepipe,
    WaitingDialogComponent,
    AnimalImageContainerComponent,
    AnimalVideoContainerComponent,
    BarcodeScannerComponent,
    CalendarMaxDateDirective,
    AnimalInStockIconComponent,
    AnimalLabelsComponent,
    CustomDatePickerComponent,
    MediaUploadComponent,
    AnimalListItemComponent,
    BodyConditionScoreComponent,
    MotherSelectComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslocoModule,
    ReactiveFormsModule,
    RouterModule,
    // PRIME NG
    ToastModule,
    MenubarModule,
    TieredMenuModule,
    AvatarModule,
    ButtonModule,
    RippleModule,
    AccordionModule,
    SelectModule,
    InputTextModule,
    FileUploadModule,
    ProgressSpinnerModule,
    ScrollTopModule,
    ImageModule,
    PaginatorModule,
    TableModule,
    DialogModule,
    DatePickerModule,
    TooltipModule,
    ScrollerModule,
    ToggleSwitchModule,
    TabsModule,
    DynamicDialogModule,
    PanelModule,
    SelectButtonModule,
    DividerModule,
    CheckboxModule,
    InputGroupModule,
    IftaLabelModule,
    InputGroupAddonModule,
    Chip,
    Fieldset,
    SkeletonModule,
    InputOtpModule,
    AnimalUniqueCheckDirective,
    MultiSelectModule,
    SignaturePadComponent,
    PdfViewerComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    TranslocoModule,
    ReactiveFormsModule,
    // PRIME NG
    ToastModule,
    MultiSelectModule,
    MenubarModule,
    TieredMenuModule,
    AvatarModule,
    ButtonModule,
    RippleModule,
    AccordionModule,
    DialogModule,
    SelectModule,
    InputTextModule,
    YearDatepipe,
    ProgressSpinnerModule,
    WaitingDialogComponent,
    ScrollTopModule,
    AnimalImageContainerComponent,
    AnimalVideoContainerComponent,
    PaginatorModule,
    TableModule,
    BarcodeScannerComponent,
    DatePickerModule,
    CalendarMaxDateDirective,
    TooltipModule,
    AnimalInStockIconComponent,
    AnimalLabelsComponent,
    ScrollerModule,
    CustomDatePickerComponent,
    ToggleSwitchModule,
    TabsModule,
    PanelModule,
    SelectButtonModule,
    MediaUploadComponent,
    CheckboxModule,
    InputGroupModule,
    IftaLabelModule,
    InputGroupAddonModule,
    InputOtpModule,
    AnimalListItemComponent,
    AnimalUniqueCheckDirective,
    BodyConditionScoreComponent,
    MotherSelectComponent,
    SignaturePadComponent,
    PdfViewerComponent,
    DividerModule
  ],
  providers: [
    DatePipe, DialogService
  ]
})
export class SharedModule {

}
